import React, { useContext } from 'react'
import RSRLMultipleBar from './RSRLMultipleBar'
import { useStaticQuery, graphql } from 'gatsby'

import { AccordionContext } from '../AccordionPage'

export default props => {
  const data = useStaticQuery(query)
  const edges = data.allRsrlIndicateursXlsxRotation.edges
  const page = props.page
  const slug = useContext(AccordionContext)

  let labels = edges.map((row, i) => row.node.ANNEE)
  let values1 = edges.map((row, i) => row.node.MOYENNE)
  let values2 = edges.map((row, i) => row.node.DEPARTS)
  let values3 = edges.map((row, i) => row.node.TAUX_ROTATION)

  let datasets = [
    {
      borderWidth: 0,
      stack: 'Moyenne',
      label: 'Moyenne',
      data: values1,
      backgroundColor: '#b82079',
    },
    {
      borderWidth: 0,
      stack: 'Départs',
      label: 'Départs',
      data: values2,
      backgroundColor: '#d3adc7',
    },
    {
      borderWidth: 0,
      stack: 'Taux de rotation',
      label: 'Taux de rotation',
      data: values3,
      backgroundColor: '#9b005b',
    },
  ]

  return (
    <div className="text-content accordion-content accordion-table">
      <div
        className="beforeCanvas"
        dangerouslySetInnerHTML={{ __html: page.acf.headlines }}
      />
      <RSRLMultipleBar
        key={slug}
        labels={labels}
        datasets={datasets}
        ylabel={"Nombre d'employés"}
      />
      <div
        className="afterCanvas"
        dangerouslySetInnerHTML={{ __html: page.content }}
      />
    </div>
  )
}

const query = graphql`
  query {
    allRsrlIndicateursXlsxRotation {
      edges {
        node {
          TITRE
          ANNEE
          MOYENNE
          DEPARTS
          TAUX_ROTATION
        }
      }
    }
  }
`
